<template>
  <div class="container">
    <!-- 音乐 -->
    <div class="music">
      <img
        src="./assets/music-svg.svg"
        @click="musicClick"
        :class="audioClass"
      />
      <audio ref="audio" :src="sound" loop>浏览器不支持音频播放</audio>
    </div>

    <!-- page内容 -->
    <transition
      enter-active-class="animate__bounceIn animate__animated"
      leave-active-class="animate__fadeOut animate__animated"
      mode="out-in"
      appear
    >
      <component :is="page" @pageChange="change" />
    </transition>
  </div>
</template>

<script>
import Hello from './components/Hello.vue'
import Past from './components/Past.vue'
import Message from './components/Message.vue'

import sound from './assets/▶-How-Deep-Is-Your-Love.mp3'

import { ref } from 'vue'

export default {
  name: 'App',
  components: {
    Hello,
    Past,
    Message
  },
  setup() {
    let page = ref('Hello')

    const audioClass = ref('stop')
    const audio = ref(null)

    let flag = false
    const musicClick = () => {
      // console.log(flag)
      if (flag) {
        flag = false
        audio.value.pause()
        audioClass.value = 'stop'
      } else {
        flag = true
        audio.value.play()
        audioClass.value = 'start'
      }
    }

    const change = (item) => {
      // console.log(item)
      page.value = item
    }

    return {
      page,
      change,
      sound,
      audioClass,
      audio,
      musicClick
    }
  }
}
</script>

<style>
.music {
  position: fixed;
  top: 20px;
  right: 20px;
  z-index: 10;
}

.music img {
  width: 45px;
  height: 45px;
  animation: music 2s linear infinite;
}

.stop {
  animation-play-state: paused !important;
}
.start {
  animation-play-state: running !important;
}

#app,
.container {
  width: 100%;
  height: 100%;
}
/* 音乐 */
@keyframes music {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

@media screen and (max-width: 767px) {
  .music img {
    /* top: 10px;
    right: 10px; */
    width: 30px;
    height: 30px;
  }
}
</style>
